import React from "react";
import { FormattedMessage } from "react-intl";
import * as R from "ramda";
import { useRouteMatch, useHistory } from "react-router-dom";
import { Box, Button, Grid, Icon, Text, Tooltip } from "@chakra-ui/react";
import { BsFillCreditCardFill } from "react-icons/bs";

export const isWallet = R.propEq("provider", "wallet");
export const isPaypal = R.propEq("provider", "paypal");

export const makePMTitleMap = (formatMessage) => ({
  payout: formatMessage({
    defaultMessage: "Add a payout method to your account",
    description: "Button label",
  }),
  purchase: formatMessage({
    defaultMessage: "Add a purchase method to your account",
    description: "Button label",
  }),
});

export const titleMap = {
  payout: "Add a payout method to your account",
  purchase: "Add a purchase method to your account",
};

export const AddCCButton = ({ amountExceedsMax, newUI, description }) => {
  const { url } = useRouteMatch();
  const history = useHistory();

  if (newUI) {
    return (
      <Box p="4" boxShadow="base" cursor="pointer" onClick={() => history.push(`${url}/addcc`)}>
        <Grid templateColumns="20px 1fr" gridGap="2" alignItems="center">
          <Icon as={BsFillCreditCardFill} boxSize="5" color="integrator.500" />
          <Text fontWeight="bold">Card</Text>
          <Box />
          <Box>{description}</Box>
        </Grid>
      </Box>
    );
  }
  return (
    <Tooltip label={amountExceedsMax ? "Amount exceeds maximum allowed" : ""} shouldWrapChildren>
      <Button
        data-testid="pm-add-cc-button"
        variant="outline"
        colorScheme="gray"
        onClick={() => history.push(`${url}/addcc`)}
        width="full"
        isDisabled={amountExceedsMax}
      >
        <FormattedMessage defaultMessage="Add Credit Card" description="Button label" />
      </Button>
    </Tooltip>
  );
};

export const CancelButton = ({ onClick }) => (
  <Button
    data-testid="pm-cancel-button"
    variant="outline"
    colorScheme="gray"
    onClick={onClick}
    width="full"
  >
    <FormattedMessage defaultMessage="Cancel" description="Button label" />
  </Button>
);
